import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

function Video({ src, type, poster, classes }) {
  return (
    <video autoPlay muted loop poster={poster} className={classes.root}>
      <source src={src} type={type} />
    </video>
  );
}

Video.propTypes = {
  classes: PropTypes.object.isRequired,
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
  type: PropTypes.oneOf(['video/webm', 'video/mp4', 'video/ogg']).isRequired,
};

Video.defaultProps = {
  poster: null,
};

const stylesheet = theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    width: 'auto',
    height: 'auto',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

export default injectSheet(stylesheet)(Video);



// WEBPACK FOOTER //
// ./src/site-render/src/Video/Video.js